import {
  AddTicketPage,
  AddUsersPage,
  AssignUserProjects,
  Contact,
  DetailTicketPage,
  EditUsersPage,
  ReportsPage,
  SettingPage,
  Ticket,
  UsersPage,
  AdminDashboard,
  CustomerDashboard,
} from "./pages";
import { withNavigationWatcher } from "./contexts/navigation";
import Customer from "./pages/customers/Customer";
import { AddCustomer } from "./pages";
import EditCustomerPage from "./pages/customers/editCustomerPage/EditCustomerPage";
import Profile from "./pages/profile/profile";
import CustomerProfile from "./pages/profile/CustomerProfile";
import CompanyProfile from "./pages/profile/CompanyProfile";
import CustomerContactProfile from "./pages/profile/CustomerContactProfile";
import LogReports from "./pages/logReports/LogReports";
import AssignProjects from "./pages/customers/assignProjectsPage/AssignProjects";
import AddContact from "./pages/contact/AddContact/AddContact";
import EditContact from "./pages/contact/EditContact/EditContact";
import Configuration from "./pages/customers/configuration/Configuration";
import HelpCenter from "./pages/helpCenter/helpCenter";
import GetStarted from "./pages/helpCenter/getStarted/getStarted";
import Faq from "./pages/helpCenter/frequentQuestions/frequentQuestion";
import Projects from "./pages/Projects/Projects";
import DeveloperDashboard from "./pages/dashboard/developerDashboard";
import CustContactDash from "./pages/dashboard/custContactDash";
const routes = [
  {
    path: "/ticket",
    element: Ticket,
  },
  {
    path: "/ticket/Add-New",
    element: AddTicketPage,
  },
  {
    path: "/ticket/Details-of-Ticket",
    element: DetailTicketPage,
  },
  {
    path: "/client",
    element: Customer,
  },
  {
    path: "/client/Add-client",
    element: AddCustomer,
  },
  {
    path: "/client/Edit-client",
    element: EditCustomerPage,
  },
  {
    path: "/client/Assign-Projects",
    element: AssignProjects,
  },
  {
    path: "/Developer",
    element: UsersPage,
  },
  {
    path: "/Developer/Add-Developer",
    element: AddUsersPage,
  },
  {
    path: "/Developer/Edit-Developer",
    element: EditUsersPage,
  },
  {
    path: "/Developer/Assign-Projects",
    element: AssignUserProjects,
  },
  {
    path: "/Profile",
    element: Profile,
  },
  {
    path: "/CustomerProfile",
    element: CustomerProfile,
  },
  {
    path: "/CompanyProfile",
    element: CompanyProfile,
  },
  {
    path: "/CustomerContactProfile",
    element: CustomerContactProfile,
  },
  {
    path: "/configuration",
    element: SettingPage,
  },
  {
    path: "/Reports",
    element: ReportsPage,
  },
  {
    path: "/Log-Reports",
    element: LogReports,
  },
  {
    path: "/adminDashboard",
    element: AdminDashboard,
  },
  {
    path: "/customerDashboard",
    element: CustomerDashboard,
  },
  {
    path: "/developerDashboard",
    element: DeveloperDashboard,
  },
  {
    path: "/custContactDash",
    element: CustContactDash,
  },
  {
    path: "/contact",
    element: Contact,
  },
  {
    path: "/contact/Add-Contact",
    element: AddContact,
  },
  {
    path: "/contact/Edit-Contact",
    element: EditContact,
  },
  {
    path: "/client-configuration",
    element: Configuration,
  },
  {
    path: "/developer-configuration",
    element: Configuration,
  },
  {
    path: "/contact-configuration",
    element: Configuration,
  },
  {
    path: "/projects",
    element: Projects,
  },
  {
    path: "/help-center",
    element: HelpCenter,
  },
  {
    path: "/help-center/get-started",
    element: GetStarted,
  },
  {
    path: "/help-center/FAQs",
    element: Faq,
  },
];

export default routes.map((route) => {
  return {
    ...route,
    element: withNavigationWatcher(route.element, route.path),
  };
});
